import styled from 'styled-components';
import { Replay as ReplayIcon } from '@mui/icons-material';

export const LoadIndicatorContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  min-width: 260px;
  height: 40px;
  padding: 8px 10px 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  position: relative;
  * {
    box-sizing: border-box;
  }
`;

export const LoadIndicatorLabel = styled.div`
  font-size: 10px;
  color: #218168;
  text-align: center;
  line-height: 100%;
`;

export const LoadIndicatorProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LoadIndicatorProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 14px;
  padding: 1px;
  background: #5ebfa4;
  margin-top: 3px;
`;

export const LoadIndicatorProgress = styled.div`
  display: flex;
  height: 12px;
  background: #238469;
  font-size: 9px;
  color: #fff;
`;

export const LoadIndicatorProgressInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 12px;
  margin-top: -12px;
  font-size: 10px;
  color: #fff;
`;

export const LoadIndicatorReloadTrigger = styled(ReplayIcon)`
  font-size: 24px;
  cursor: pointer;
  color: #218168;
  margin-left: 10px;
`;
